<template>
  <section>
    <v-col>
      <!-- Back button -->
      <v-row class="ma-0 mb-4">
        <v-btn color="secondary" class="text-capitalize" @click="onBack">{{
          $translate('BACK')
        }}</v-btn>
      </v-row>

      <h2>{{ $translate('SUBSCRIPTION_STEP2') }}</h2>
      <div class="text-subtitle-1 text--secondary">
        {{ $translate('SUBSCRIPTION_REPETITION_TITLE') }}
      </div>

      <v-radio-group
        v-model="selectedRepetiton"
        hide-details="auto"
        column
        @change="onRepetitionChange"
      >
        <v-radio
          v-for="(repetition, index) in repetitionOptions"
          :key="index"
          :value="repetition.Value"
        >
          <template v-slot:label>
            <div class="text-subtitle-1 text--primary">
              {{ repetition.Text }}
            </div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-card flat color="grey lighten-3" class="mt-6 mb-3" width="100%">
        <v-card-text class="text-subtitle-1 text--primary">
          {{ $translate('SUBSCRIPTION_TO_DELIVERY_EXPLAN') }}
        </v-card-text>
      </v-card>

      <!-- Next button -->
      <v-row class="ma-0 mt-4" justify="end">
        <v-btn
          color="primary"
          class="text-capitalize primary-font-color"
          @click="onNext"
          >{{ $translate('NEXT') }}</v-btn
        >
      </v-row>
    </v-col>
  </section>
</template>

<script>
export default {
  name: 'SubscriptionFrequency',
  data() {
    return {
      selectedRepetiton: 1,
      repetitionOptions: [
        {
          Value: 4,
          Text: this.$translate('EVERY_FOUR_WEEKS'),
        },
        {
          Value: 3,
          Text: this.$translate('EVERY_THREE_WEEKS'),
        },
        {
          Value: 2,
          Text: this.$translate('EVERY_TWO_WEEKS'),
        },
        {
          Value: 1,
          Text: this.$translate('EVERY_WEEK'),
        },
      ],
    };
  },
  mounted() {
    this.initRepetiton();
  },
  methods: {
    initRepetiton() {
      this.selectedRepetiton = 1;
      const repetitionStore =
        this.$store.getters['subscription/repetitionFrequency'];
      if (
        repetitionStore != null &&
        typeof repetitionStore === 'number' &&
        repetitionStore >= 1
      ) {
        this.selectedRepetiton = repetitionStore;
      }
    },
    onRepetitionChange() {
      this.$store.commit(
        'subscription/setRepetitionFrequency',
        this.selectedRepetiton
      );
    },
    onBack() {
      this.$emit('back');
    },
    onNext() {
      this.$emit('next');
    },
  },
};
</script>
